import { createAction } from '@reduxjs/toolkit';
import {
  RequestError,
  ServicesPassengersConcernedByCommunicationParams,
  ServicesPassengersConcernedByCommunicationResponse,
} from 'types';
import { State } from './types';

export const fetchServicesPassengersConcernedByCommunication = createAction(
  'services-passengers-concerned-by-communication/fetch',
  (
    communicationParams: ServicesPassengersConcernedByCommunicationParams,
    callback?: (data?: ServicesPassengersConcernedByCommunicationResponse) => void
  ) => ({
    payload: communicationParams,
    meta: { callback },
  })
);

export const fetchedServicesPassengersConcernedByCommunication = createAction(
  'services-passengers-concerned-by-communication/fetched',
  (data?: State['data'], error?: RequestError) => ({
    payload: { data, error },
    error: Boolean(error),
  })
);

export default {
  fetchServicesPassengersConcernedByCommunication,
  fetchedServicesPassengersConcernedByCommunication,
};
